import snackbarTemplate from '@/plugins/snackbar/SnackbarTemplate.vue'

const SNACKBAR_COLORS = {
  error: '#F15435',
  success: '#0A8533',
  primary: '#002040',
}

const SNACKBAR_BUTTON_COLORS = {
  'cinza-d20': '#31363B',
}
/* eslint-disable prefer-promise-reject-errors */
export default {
  install(Vue) {
    let SnackbarConstructor = Vue.extend(snackbarTemplate)
    let snackbarInstance = null
    Vue.prototype.$snackbar = (config) => {
      return new Promise((resolve, reject) => {
        if (snackbarInstance) return
        snackbarInstance = new SnackbarConstructor({
          el: document.createElement('div'),
          data() {
            return {
              message: config.message || 'Ocorreu um erro, tente novamente',
              btnText: config.btnText,
              btnColor: config.btnColor ? SNACKBAR_BUTTON_COLORS[config.btnColor] || config.btnColor : '#31363B',
              snackbarColor: config.snackbarColor ? SNACKBAR_COLORS[config.snackbarColor] || config.snackbarColor : 'grey darken-1',
              timeout: config.timeout,
              actionCallback: config.actionCallback || null,
            }
          },
          methods: {
            closeSnackbar() {
              if (snackbarInstance) snackbarInstance.open = false
              snackbarInstance = null
              resolve()
            },
            clickButton() {
              if (snackbarInstance) snackbarInstance.actionCallback()
              this.closeSnackbar()
            },
          },
        })
        snackbarInstance.open = true
        document.body.appendChild(snackbarInstance.$el)
      })
    }
  },
}
